@if (bannerVideo$ | async; as bannerVideo) {
  <h2 class="text-b2-s text-md-b2-m text-lg-h4-s banner-video-title container-v2">
    {{ bannerVideo.label }}
  </h2>
  <div class="banner-video-container container-v2">
    <iframe
      loading="lazy"
      [src]="bannerVideo.link | sdSafeResourceUrl"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
    ></iframe>
  </div>
} @else if (isLoading$ | async) {
  <div class="container-v2 banner-video-skeleton sd-group-skeleton-gradient-wave">
    <div class="banner-video-title sd-skeleton"></div>
    <div class="banner-video-container sd-skeleton"></div>
  </div>
}
